<template>
    <div class="fixed inset-0 flex items-center justify-center bg-gray-500 bg-opacity-50" v-if="loading">
        <!-- Rolling circle preloader -->
        <div class="animate-spin rounded-full h-12 w-12 border-4 border-slate-800 border-t-slate-200 border-solid"></div>
    </div>
    <div v-else>
        <div class="bg-slate-100 h-screen px-4 lg:px-24 py-5">
            <div class="">
                <div class="flex justify-between">
                    <RouterLink to="/">
                    <h4 class="font-zilla text-2xl lg:text-4xl font-extrabold">Gitly</h4>
                    </RouterLink>
                    <RouterLink to="/">
                    <span class="material-symbols-outlined text-2xl lg:text-4xl font-extrabold ">
                        logout
                    </span>
                </RouterLink>
                    
                </div>

                <div class="flex items-center justify-center mt-2 mb-5">
                    <h3 class="font-zilla text-xl lg:text-3xl text-center">Repositories</h3><span
                        class="material-symbols-outlined text-2xl">deployed_code_update</span>

            
                    </div>
                    <div class="flex items-center">
                <span
                    class="bg-white flex justify-center  w-36 lg:w-[40vh] py-1 rounded-sm border border-slate-500 hover:border-slate-800 focus:border-slate-800">

                    <input v-model="searchTerm" placeholder="Find"
                        class="bg-white w-20 lg:w-[25vh] outline-none text-sm font-zilla" />
                    <span class="material-symbols-outlined text-md ">frame_inspect</span>
                </span>
      <h3 class="font-zilla text-md text-slate-500 ml-4 ">Tap blocks for more Info</h3>
      </div>

            </div>
            <div v-if="filteredRepos.length > 0">
                <div id="" v-for="(repo, index) in filteredRepos" :key="repo.id"
                    class="expandableDiv flex justify-between mt-2 w-full h-20 bg-slate-200 border-t border-b border-slate-600"
                    @click="toggleHeight(index)">
                    <div class="flex flex-col">
                        <div class="flex flex-col mx-2 my-2 ">
                            <div class="flex items-center">
                                <h3 class="font-zilla text-center font-bold">{{ repo.name }}</h3>
                                <span v-if="repo.visibility === 'private'"
                                    class="material-symbols-outlined text-lg">lock</span>
                                <span v-else class="material-symbols-outlined text-lg">Public</span>
                            </div>
                            <div>
                                <i><h5 class="font-zilla bg-slate-300 px-2 inline-block rounded-sm text-sm">owner:
                                    {{ repo.owner.login }}</h5></i>
                            </div>
                        </div>
                        <div class="additionalContent" style="display: none;">
                            <div class=" flex-row mx-2 my-2">
                                <h5 class="font-zilla text-sm inline-block"> Description : {{ repo.description }} </h5>
                                <h5 class="font-zilla text-sm"> Created at : {{ formatDate(repo.created_at) }}</h5>
                                <h5 class="font-zilla text-sm"> Last updated: {{ formatDate(repo.updated_at) }} </h5>
                                <a :href="`https://github.com/${repo.owner.login}/${repo.name}`"
                                    class="font-zilla bg-green-400 px-2 inline-block rounded-sm text-sm">view
                                    commits</a><br />
                                <a :href="`https://github.com/${repo.owner.login}/${repo.name}/issues`"
                                    class="font-zilla bg-red-600 px-2 inline-block rounded-sm text-sm">view
                                    issues</a>
                            </div>

                        </div>
                    </div>
                    <a :href="repo.html_url"
                        class="mx-2 my-2 h-10 rounded-sm flex items-center px-2  bg-slate-300 border border-slate-950 ">
                        <h4 class="font-zilla font-bold text-xs "> View </h4>
                        <span class="material-symbols-outlined text-sm">
                            whatshot
                        </span>
                    </a>
                </div>
            </div>

            <div v-else>
                <div v-for="(repo, index) in Repositories" :key="repo.id"
                    class="expandableDiv flex justify-between mt-2 w-full h-20 bg-slate-200 border-t border-b border-slate-600"
                    @click="toggleHeight(index)">
                    <div class="flex flex-col">
                        <div class="flex flex-col mx-2 my-2 ">
                            <div class="flex items-center">
                                <h3 class="font-zilla text-lg text-center font-bold ">{{ repo.name }}</h3>
                                <span v-if="repo.visibility === 'private'"
                                    class="material-symbols-outlined text-lg">lock</span>
                                <span v-else class="material-symbols-outlined text-lg">Public</span>
                            </div>
                            <div>
                               <i> <h5 class="font-zilla bg-slate-300 px-2 inline-block rounded-sm text-sm">owner:
                                    {{ repo.owner.login }}</h5></i>
                            </div>
                        </div>
                        <div class="additionalContent" style="display: none;">
                            <div class=" flex-row mx-2 my-2">
                                <h5 class="font-zilla text-sm inline-block"> Description : {{ repo.description }} </h5>
                                <h5 class="font-zilla text-sm"> Created at : {{ formatDate(repo.created_at) }}</h5>
                                <h5 class="font-zilla text-sm"> Last updated: {{ formatDate(repo.updated_at) }} </h5>
                                <a :href="`https://github.com/${repo.owner.login}/${repo.name}`"
                                    class="font-zilla bg-green-400 px-2 inline-block rounded-sm text-sm">view
                                    commits</a><br />
                                <a :href="`https://github.com/${repo.owner.login}/${repo.name}/issues`"
                                    class="font-zilla bg-red-600 px-2 inline-block rounded-sm text-sm">view
                                    issues</a>
                            </div>

                        </div>
                    </div>
                    <a :href="repo.html_url"
                        class="mx-2 my-2 h-10 rounded-sm flex items-center px-2  bg-slate-300 border border-slate-950 ">
                        <h4 class="font-zilla font-bold text-xs "> View </h4>
                        <span class="material-symbols-outlined text-sm">
                            whatshot
                        </span>
                    </a>
                </div>
            </div>

        </div>

    </div>
</template>

<script>
import axios from 'axios'
export default {
    data() {
        return {
            loading: false,
            Repositories: [],
            searchTerm: "",
        }
    },
    methods: {
        formatDate(created_at) {
            const date = new Date(created_at);
            return date.toLocaleString(); // Adjust the format as needed
        },
        toggleHeight(index) {
            const expandableDiv = document.getElementsByClassName('expandableDiv')[index];
            const additionalContent = document.getElementsByClassName('additionalContent')[index];

            if (expandableDiv.classList.contains('h-20')) {
                expandableDiv.classList.remove('h-20');
                expandableDiv.classList.add('h-52');
                additionalContent.style.display = 'block';
            } else {
                expandableDiv.classList.remove('h-52');
                expandableDiv.classList.add('h-20');
                additionalContent.style.display = 'none';
            }
        },
        async fetchData() {
            const code = this.$route.query.code;

            // making API  request 
            try {
                const res = await axios.get(`https://quasar1.up.railway.app/login/callback?code=${code}`)
                console.log(res.data)
                this.Repositories = res.data.repositories
                this.loading = false
                localStorage.setItem('gitly_token', res.data.access_token)
            } catch (err) {
                console.log(err)
            }
        },
        async handleRefresh() {

            this.loading = true
            try {
                const access_token = localStorage.getItem('gitly_token')
                //  const token =  { access_token : access_token}
                if (!access_token) {
                    this.$router.push('/')
                }
                const res = await axios.get(`https://quasar1.up.railway.app/user/repos?honur=${access_token}`)
                if (res.status == 200) {
                    console.log(res.data)
                    this.Repositories = res.data.repositories
                    this.loading = false
                }
            } catch (error) {
                console.log(error)
            }

        }
    },
    computed: {
        // filteredRepos() {
        //     const term = this.searchTerm.toLowerCase();
        //     return this.Repositories.filter((repo) => repo.name.toLowerCase().includes(term) || repo.description.toLowerCase().includes(term))
        // }
        filteredRepos() {
            const term = this.searchTerm.toLowerCase();
          //  console.log('Search term:', term);
            const filtered = this.Repositories.filter((repo) => {
                const name = repo.name ? repo.name.toLowerCase() : '';
                const description = repo.description ? repo.description.toLowerCase() : '';

                return name.toLowerCase().includes(term) || description.toLowerCase().includes(term)
            }
            );
            return filtered;
        }
    },
    mounted() {
        //  Check if the session has expired or isFirstLoad flag is not set
        const lastVisitTime = localStorage.getItem('lastVisitTime');
        const isFirstLoad = localStorage.getItem('isFirstLoad');

        if (!lastVisitTime || !isFirstLoad) {
            // Run the initial fetch
            this.fetchData();

            // Set flags and update last visit time
            localStorage.setItem('isFirstLoad', 'true');
            localStorage.setItem('lastVisitTime', new Date().toISOString());
        } else {
            // Check if the session has expired (e.g., 1 hour in this example)
            const expirationTime = 60 * 60 * 1000; // 1 hour in milliseconds
            const currentTime = new Date().getTime();

            if (currentTime - new Date(lastVisitTime).getTime() > expirationTime) {
                // Session has expired, run the refresh handling function
                this.handleRefresh();
            } else {
                this.handleRefresh()
                //Session still valid, do nothing or handle accordingly
            }
        }
    }
}


</script>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Zilla+Slab:wght@500&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Lato:ital@1&family=Montserrat:wght@600&display=swap');

.material-symbols-outlined {
    font-variation-settings:
        'FILL' 0,
        'wght' 400,
        'GRAD' 0,
        'opsz' 24
}
</style>